import React from 'react';

const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

type Props = {
  size?: 'normal' | 'small';
};

const DatepickerDaysOfWeek: React.FC<Props> = ({ size = 'normal' }) => {
  const textSize = size === 'small' ? 'text-xs' : 'text-md';

  return (
    <>
      {dayNames.map(day => (
        <div
          key={day}
          className={`col-span-1 text-center text-gray-400 dark:text-gray-300 ${textSize}`}
        >
          {day}
        </div>
      ))}
    </>
  );
};

export default DatepickerDaysOfWeek;
